import { onValue, push, ref, remove, update } from 'firebase/database';
import { useEffect, useState } from 'react';
import { database } from '../firebase';

const CITIES = ['Agar Malwa','Alirajpur','Anuppur','Ashok Nagar','Balaghat','Barwani','Betul','Bhind','Bhopal','Burhanpur','Chhatarpur','Chhindwara','Damoh','Datia','Dewas','Dhar','Dindori','Guna','Gwalior','Harda','Hoshangabad','Indore','Jabalpur','Jhabua','Katni','Khandwa','Khargone','Mandla','Mandsaur','Morena','Narsinghpur','Neemuch','Panna','Raisen','Rajgarh','Ratlam','Rewa','Sagar','Satna','Sehore','Seoni','Shahdol','Shajapur','Sheopur','Shivpuri','Sidhi','Singrauli','Tikamgarh','Ujjain','Umaria','Vidisha'];

const EMPTY_STUDENT = { name:'', gender:'', dob:'', mobile:'', altMobile:'', email:'', qualification:'', parentName:'', parentMobile:'', date: new Date().toISOString().split('T')[0], status:'Active', remarks:'', course:'', batch:'', batchTiming:'', startDate:'', endDate:'', source:'', totalFees:'', feesPaid:'', paymentMode:'', receiptNo:'', idType:'', idNumber:'', state:'Madhya Pradesh', city:'', pincode:'', address:'' };

const AddStudentModal = ({ onClose, onAdd }) => {
  const [form, setForm] = useState({ ...EMPTY_STUDENT });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleAdd = async () => {
    if (!form.name || !form.mobile) { alert('Name and Mobile are required.'); return; }
    // basic validations
    if (form.mobile && form.mobile.replace(/\D/g, '').length < 10) { alert('Enter a valid 10 digit mobile number.'); return; }
    if (form.parentMobile && form.parentMobile.replace(/\D/g, '').length > 0 && form.parentMobile.replace(/\D/g, '').length < 10) { alert("Enter a valid parent's mobile number."); return; }
    if (form.pincode && form.pincode.replace(/\D/g, '').length > 0 && form.pincode.replace(/\D/g, '').length < 6) { alert('Enter a valid 6 digit pincode.'); return; }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { alert('Enter a valid email address.'); return; }
    setSaving(true);
    await onAdd(form);
    setSaving(false);
    onClose();
  };

  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header py-2" style={{ background: '#90b732' }}>
            <h6 className="modal-title text-white mb-0"><i className="bi bi-person-plus me-2"></i>Add New Student</h6>
            <button className="btn-close btn-close-white btn-sm" onClick={onClose}></button>
          </div>
          <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
            <div className="row g-2" style={{ fontSize: '13px' }}>
              <div className="col-12"><h6 className="mb-2">Personal</h6></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Name <span className="text-danger">*</span></label><input className="form-control form-control-sm" value={form.name} onChange={e => set('name', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Gender</label><select className="form-select form-select-sm" value={form.gender} onChange={e => set('gender', e.target.value)}><option value="">Select</option><option>Male</option><option>Female</option></select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Date of Birth</label><input type="date" className="form-control form-control-sm" value={form.dob} onChange={e => set('dob', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Mobile <span className="text-danger">*</span></label><input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.mobile} onChange={e => set('mobile', e.target.value.replace(/\D/g, ''))} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Alt. Mobile</label><input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.altMobile} onChange={e => set('altMobile', e.target.value.replace(/\D/g, ''))} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Email</label><input type="email" className="form-control form-control-sm" value={form.email} onChange={e => set('email', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Qualification</label><select className="form-select form-select-sm" value={form.qualification} onChange={e => set('qualification', e.target.value)}><option value="">Select</option>{['Any Graduate','X Standard','ITI/Diploma','XII Standard','B.Com','B.E/B.Tech','BBA/BBM','M.Com','MBA','Professional qualification','Other'].map(q => <option key={q}>{q}</option>)}</select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Parent's Name</label><input className="form-control form-control-sm" value={form.parentName} onChange={e => set('parentName', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Parent's Mobile</label><input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.parentMobile} onChange={e => set('parentMobile', e.target.value.replace(/\D/g, ''))} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Date Added</label><input type="date" className="form-control form-control-sm" value={form.date} onChange={e => set('date', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Status</label><select className="form-select form-select-sm" value={form.status} onChange={e => set('status', e.target.value)}><option value="">Select</option>{['Active','Inactive','Completed','Dropped'].map(s => <option key={s}>{s}</option>)}</select></div>
              <div className="col-md-8"><label className="form-label mb-1 fw-semibold">Remarks</label><textarea className="form-control form-control-sm" rows={2} value={form.remarks} onChange={e => set('remarks', e.target.value)} /></div>

              <div className="col-12 mt-2"><h6 className="mb-2">Course & Fees</h6></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Course</label><select className="form-select form-select-sm" value={form.course} onChange={e => set('course', e.target.value)}><option value="">Select</option>{['Tally Professional','Tally Expert','GST Course','TallyEssential','Office Automation','Payroll & Income Tax'].map(c => <option key={c}>{c}</option>)}</select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Batch</label><input className="form-control form-control-sm" value={form.batch} onChange={e => set('batch', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Batch Timing</label><input className="form-control form-control-sm" value={form.batchTiming} onChange={e => set('batchTiming', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Start Date</label><input type="date" className="form-control form-control-sm" value={form.startDate} onChange={e => set('startDate', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">End Date</label><input type="date" className="form-control form-control-sm" value={form.endDate} onChange={e => set('endDate', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Source</label><input className="form-control form-control-sm" value={form.source} onChange={e => set('source', e.target.value)} /></div>
              <div className="col-12"><hr className="my-1" /><small className="text-muted fw-semibold">Fee Details</small></div>
              <div className="col-md-3"><label className="form-label mb-1 fw-semibold">Total Fees (₹)</label><input type="number" className="form-control form-control-sm" value={form.totalFees} onChange={e => set('totalFees', e.target.value)} /></div>
              <div className="col-md-3"><label className="form-label mb-1 fw-semibold">Fees Paid (₹)</label><input type="number" className="form-control form-control-sm" value={form.feesPaid} onChange={e => set('feesPaid', e.target.value)} /></div>
              <div className="col-md-3"><label className="form-label mb-1 fw-semibold">Balance (₹)</label><input type="number" className="form-control form-control-sm" value={(Number(form.totalFees||0)-Number(form.feesPaid||0))||''} readOnly style={{ background:'#f8f9fa' }} /></div>
              <div className="col-md-3"><label className="form-label mb-1 fw-semibold">Payment Mode</label><select className="form-select form-select-sm" value={form.paymentMode} onChange={e => set('paymentMode', e.target.value)}><option value="">Select</option>{['Cash','Online','Cheque','DD'].map(m => <option key={m}>{m}</option>)}</select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Receipt No.</label><input className="form-control form-control-sm" value={form.receiptNo} onChange={e => set('receiptNo', e.target.value)} /></div>

              <div className="col-12 mt-2"><h6 className="mb-2">ID & Address</h6></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">ID Proof Type</label><select className="form-select form-select-sm" value={form.idType} onChange={e => set('idType', e.target.value)}><option value="">Select</option>{['Aadhar','PAN','Voter ID','Passport','Driving License','Ration Card'].map(t => <option key={t}>{t}</option>)}</select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">ID Proof Number</label><input className="form-control form-control-sm" value={form.idNumber} onChange={e => set('idNumber', e.target.value)} /></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">State</label><select className="form-select form-select-sm" value={form.state} onChange={e => set('state', e.target.value)}><option value="">Select</option><option>Madhya Pradesh</option></select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">City</label><select className="form-select form-select-sm" value={form.city} onChange={e => set('city', e.target.value)}><option value="">Select</option>{CITIES.map(c => <option key={c}>{c}</option>)}</select></div>
              <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Pincode</label><input inputMode="numeric" maxLength={6} className="form-control form-control-sm" value={form.pincode} onChange={e => set('pincode', e.target.value.replace(/\D/g, ''))} /></div>
              <div className="col-12"><label className="form-label mb-1 fw-semibold">Address</label><textarea className="form-control form-control-sm" rows={2} value={form.address} onChange={e => set('address', e.target.value)} /></div>
            </div>
          </div>
          <div className="modal-footer py-2 d-flex justify-content-end gap-2">
            <button className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={handleAdd} disabled={saving}>
              {saving ? 'Saving...' : <><i className="bi bi-person-plus me-1"></i>Add Student</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditModal = ({ record, onClose, onSave, onDelete }) => {
  const [form, setForm] = useState({ ...record });
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('personal');
  const set = (key, val) => setForm(p => ({ ...p, [key]: val }));

  const handleSave = async () => {
    // validations before save
    if (form.mobile && form.mobile.replace(/\D/g, '').length < 10) { alert('Enter a valid 10 digit mobile number.'); return; }
    if (form.parentMobile && form.parentMobile.replace(/\D/g, '').length > 0 && form.parentMobile.replace(/\D/g, '').length < 10) { alert("Enter a valid parent's mobile number."); return; }
    if (form.pincode && form.pincode.replace(/\D/g, '').length > 0 && form.pincode.replace(/\D/g, '').length < 6) { alert('Enter a valid 6 digit pincode.'); return; }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { alert('Enter a valid email address.'); return; }
    setSaving(true);
    await onSave(form);
    setSaving(false);
    onClose();
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this record permanently?')) return;
    await onDelete(record.id);
    onClose();
  };

  const fmtDate = (val) => val ? new Date(val).toISOString().split('T')[0] : '';

  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header py-2" style={{ background: '#90b732' }}>
            <h6 className="modal-title text-white mb-0"><i className="bi bi-pencil-square me-2"></i>Edit Student — {record.name}</h6>
            <button className="btn-close btn-close-white btn-sm" onClick={onClose}></button>
          </div>

          <div className="px-3 pt-2" style={{ borderBottom: '1px solid #dee2e6' }}>
            <ul className="nav nav-tabs border-0" style={{ fontSize: '13px' }}>
              {[['personal','Personal'],['course','Course & Fees'],['id','ID & Address']].map(([key, label]) => (
                <li className="nav-item" key={key}>
                  <button className={`nav-link py-1 px-3 ${tab === key ? 'active fw-semibold' : 'text-muted'}`}
                    style={{ border: 'none', borderBottom: tab === key ? '2px solid #90b732' : '2px solid transparent', background: 'none', color: tab === key ? '#90b732' : '' }}
                    onClick={() => setTab(key)}>{label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
            <div className="row g-2" style={{ fontSize: '13px' }}>

              {tab === 'personal' && <>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Name</label>
                  <input className="form-control form-control-sm" value={form.name || ''} onChange={e => set('name', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Gender</label>
                  <select className="form-select form-select-sm" value={form.gender || ''} onChange={e => set('gender', e.target.value)}>
                    <option value="">Select</option>
                    <option>Male</option><option>Female</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Date of Birth</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.dob)} onChange={e => set('dob', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Mobile</label>
                  <input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.mobile || ''} onChange={e => set('mobile', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Alt. Mobile</label>
                  <input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.altMobile || ''} onChange={e => set('altMobile', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Email</label>
                  <input type="email" className="form-control form-control-sm" value={form.email || ''} onChange={e => set('email', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Qualification</label>
                  <select className="form-select form-select-sm" value={form.qualification || ''} onChange={e => set('qualification', e.target.value)}>
                    <option value="">Select</option>
                    {['Any Graduate','X Standard','ITI/Diploma','XII Standard','B.Com','B.E/B.Tech','BBA/BBM','M.Com','MBA','Professional qualification','Other'].map(q => <option key={q}>{q}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Parent's Name</label>
                  <input className="form-control form-control-sm" value={form.parentName || ''} onChange={e => set('parentName', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Parent's Mobile</label>
                  <input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.parentMobile || ''} onChange={e => set('parentMobile', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Date Added</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.date)} onChange={e => set('date', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Status</label>
                  <select className="form-select form-select-sm" value={form.status || ''} onChange={e => set('status', e.target.value)}>
                    <option value="">Select</option>
                    {['Active','Inactive','Completed','Dropped'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="col-md-8">
                  <label className="form-label mb-1 fw-semibold">Remarks</label>
                  <textarea className="form-control form-control-sm" rows={2} value={form.remarks || ''} onChange={e => set('remarks', e.target.value)} />
                </div>
              </>
              }

              {tab === 'course' && <>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Course</label>
                  <select className="form-select form-select-sm" value={form.course || ''} onChange={e => set('course', e.target.value)}>
                    <option value="">Select</option>
                    {['Tally Professional','Tally Expert','GST Course'].map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Batch</label>
                  <input className="form-control form-control-sm" value={form.batch || ''} onChange={e => set('batch', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Batch Timing</label>
                  <input className="form-control form-control-sm" value={form.batchTiming || ''} onChange={e => set('batchTiming', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Start Date</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.startDate)} onChange={e => set('startDate', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">End Date</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.endDate)} onChange={e => set('endDate', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Source</label>
                  <input className="form-control form-control-sm" value={form.source || ''} onChange={e => set('source', e.target.value)} />
                </div>
                <div className="col-12"><hr className="my-1" /><small className="text-muted fw-semibold">Fee Details</small></div>
                <div className="col-md-3">
                  <label className="form-label mb-1 fw-semibold">Total Fees (₹)</label>
                  <input type="number" className="form-control form-control-sm" value={form.totalFees || ''} onChange={e => set('totalFees', e.target.value)} />
                </div>
                <div className="col-md-3">
                  <label className="form-label mb-1 fw-semibold">Fees Paid (₹)</label>
                  <input type="number" className="form-control form-control-sm" value={form.feesPaid || ''} onChange={e => set('feesPaid', e.target.value)} />
                </div>
                <div className="col-md-3">
                  <label className="form-label mb-1 fw-semibold">Balance (₹)</label>
                  <input type="number" className="form-control form-control-sm"
                    value={(Number(form.totalFees || 0) - Number(form.feesPaid || 0)) || ''} readOnly
                    style={{ background: '#f8f9fa' }} />
                </div>
                <div className="col-md-3">
                  <label className="form-label mb-1 fw-semibold">Payment Mode</label>
                  <select className="form-select form-select-sm" value={form.paymentMode || ''} onChange={e => set('paymentMode', e.target.value)}>
                    <option value="">Select</option>
                    {['Cash','Online','Cheque','DD'].map(m => <option key={m}>{m}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Receipt No.</label>
                  <input className="form-control form-control-sm" value={form.receiptNo || ''} onChange={e => set('receiptNo', e.target.value)} />
                </div>
              </>
              }

              {tab === 'id' && <>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">ID Proof Type</label>
                  <select className="form-select form-select-sm" value={form.idType || ''} onChange={e => set('idType', e.target.value)}>
                    <option value="">Select</option>
                    {['Aadhar','PAN','Voter ID','Passport','Driving License','Ration Card'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">ID Proof Number</label>
                  <input className="form-control form-control-sm" value={form.idNumber || ''} onChange={e => set('idNumber', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">State</label>
                  <select className="form-select form-select-sm" value={form.state || ''} onChange={e => set('state', e.target.value)}>
                    <option value="">Select</option>
                    <option>Madhya Pradesh</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">City</label>
                  <select className="form-select form-select-sm" value={form.city || ''} onChange={e => set('city', e.target.value)}>
                    <option value="">Select</option>
                    {CITIES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Pincode</label>
                  <input inputMode="numeric" maxLength={6} className="form-control form-control-sm" value={form.pincode || ''} onChange={e => set('pincode', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-12">
                  <label className="form-label mb-1 fw-semibold">Address</label>
                  <textarea className="form-control form-control-sm" rows={2} value={form.address || ''} onChange={e => set('address', e.target.value)} />
                </div>
              </>
              }

            </div>
          </div>
          <div className="modal-footer py-2 d-flex justify-content-between">
            <button className="btn btn-sm btn-outline-danger" onClick={handleDelete}>
              <i className="bi bi-trash me-1"></i>Delete
            </button>
            <div className="d-flex gap-2">
              <button className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
              <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={handleSave} disabled={saving}>
                {saving ? 'Saving...' : <><i className="bi bi-check-lg me-1"></i>Save Changes</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Enrollstu = () => {
  const [allData, setAllData]           = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [search, setSearch]             = useState('');
  const [showFilters, setShowFilters]   = useState(false);
  const [selected, setSelected]         = useState([]);
  const [editRecord, setEditRecord]     = useState(null);
  const [showAdd, setShowAdd]           = useState(false);
  const [toast, setToast]               = useState('');
  const [filters, setFilters]           = useState({ mobile: '', email: '', city: '', date: '' });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3500); };

  useEffect(() => {
    const unsub = onValue(ref(database, 'Enrolled_students'), (snap) => {
      const raw = snap.val();
      const data = raw ? Object.entries(raw).map(([id, v]) => ({ id, ...v })) : [];
      setAllData(data);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    let data = [...allData];
    if (search) data = data.filter(r =>
      [r.name, r.email, r.mobile, r.course, r.city].some(f => f?.toLowerCase().includes(search.toLowerCase()))
    );
    if (filters.mobile) data = data.filter(r => r.mobile?.toLowerCase().includes(filters.mobile.toLowerCase()));
    if (filters.email)  data = data.filter(r => r.email?.toLowerCase().includes(filters.email.toLowerCase()));
    if (filters.city)   data = data.filter(r => r.city?.toLowerCase().includes(filters.city.toLowerCase()));
    if (filters.date)   data = data.filter(r => new Date(r.date).toLocaleDateString() === new Date(filters.date).toLocaleDateString());
    setFilteredData(data);
  }, [search, filters, allData]);

  const toggleSelect = (id) => setSelected(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const toggleAll    = () => setSelected(selected.length === filteredData.length ? [] : filteredData.map(r => r.id));
  const resetFilters = () => setFilters({ mobile: '', email: '', city: '', date: '' });

  const handleSave = async (form) => {
    const { id, ...data } = form;
    await update(ref(database, `Enrolled_students/${id}`), data);
    showToast('Student updated successfully.');
  };

  const handleDelete = async (id) => {
    await remove(ref(database, `Enrolled_students/${id}`));
    showToast('Student deleted.');
  };

  const handleAdd = async (form) => {
    await push(ref(database, 'Enrolled_students'), { ...form, date: form.date || new Date().toISOString() });
    showToast(`${form.name} added to Students Listing.`);
  };

  const exportCSV = () => {
    const rows = [['Name', 'Course', 'Mobile', 'Email', 'City', 'Date']];
    filteredData.forEach(r => rows.push([r.name || '', r.course || '', r.mobile || '', r.email || '', r.city || '', r.date ? new Date(r.date).toLocaleDateString() : '']));
    const a = document.createElement('a');
    a.href = 'data:text/csv,' + encodeURIComponent(rows.map(r => r.join(',')).join('\n'));
    a.download = 'students.csv';
    a.click();
  };

  return (
    <div className="px-1">
      {editRecord && (
        <EditModal
          record={editRecord}
          onClose={() => setEditRecord(null)}
          onSave={handleSave}
          onDelete={handleDelete}
        />
      )}
      {showAdd && (
        <AddStudentModal
          onClose={() => setShowAdd(false)}
          onAdd={handleAdd}
        />
      )}

      {toast && (
        <div className="alert py-2 px-3 mb-2 d-flex align-items-center gap-2" style={{ fontSize: 13, background: '#edf7d6', color: '#4d7a10', border: '1px solid #90b732' }}>
          <i className="bi bi-check-circle-fill" style={{ color: '#90b732' }}></i> {toast}
        </div>
      )}

      <div className="d-flex align-items-center justify-content-between mb-3 pb-2" style={{ borderBottom: '2px solid #90b732' }}>
        <h6 className="fw-bold mb-0" style={{ color: '#90b732' }}>
          <i className="bi bi-people me-2"></i>Students Listing
        </h6>
        <span className="badge" style={{ background: '#90b732' }}>{filteredData.length} records</span>
      </div>

      <div className="alert alert-info py-1 px-3 mb-2" style={{ fontSize: '12px' }}>
        To find college students registered before 16-09-2018, go to <strong>College → Student Listing</strong>
      </div>

      <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <div className="input-group" style={{ maxWidth: '280px' }}>
          <span className="input-group-text bg-white"><i className="bi bi-search text-muted"></i></span>
          <input type="text" className="form-control border-start-0" placeholder="Search name, email, mobile..."
            value={search} onChange={e => setSearch(e.target.value)} style={{ fontSize: '13px' }} />
        </div>
        <button className={`btn btn-sm ${showFilters ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setShowFilters(p => !p)}>
          <i className="bi bi-funnel-fill me-1"></i>Filters
        </button>
        <button className="btn btn-sm btn-outline-success" onClick={exportCSV}>
          <i className="bi bi-file-earmark-excel me-1"></i>Export
        </button>
        <div className="ms-auto d-flex gap-2 flex-wrap">
          <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={() => setShowAdd(true)}>
              <i className="bi bi-person-plus me-1"></i>Add Student
            </button>
          <button className="btn btn-sm btn-outline-secondary"><i className="bi bi-calendar-check me-1"></i>Schedule Test</button>
          <button className="btn btn-sm btn-outline-secondary"><i className="bi bi-arrow-repeat me-1"></i>Reschedule</button>
          <button className="btn btn-sm btn-outline-secondary"><i className="bi bi-three-dots me-1"></i>Other Actions</button>
        </div>
      </div>

      {showFilters && (
        <div className="card mb-3 border-primary">
          <div className="card-body py-2 px-3">
            <div className="row g-2 align-items-end">
              {[['mobile', 'Mobile'], ['email', 'Email'], ['city', 'City']].map(([key, label]) => (
                <div className="col-md-3" key={key}>
                  <label className="form-label mb-1" style={{ fontSize: '12px' }}>{label}</label>
                  <input className="form-control form-control-sm" placeholder={`Filter by ${label.toLowerCase()}`}
                    value={filters[key]} onChange={e => setFilters(p => ({ ...p, [key]: e.target.value }))} />
                </div>
              ))}
              <div className="col-md-2">
                <label className="form-label mb-1" style={{ fontSize: '12px' }}>Date</label>
                <input type="date" className="form-control form-control-sm"
                  value={filters.date} onChange={e => setFilters(p => ({ ...p, date: e.target.value }))} />
              </div>
              <div className="col-md-1">
                <button className="btn btn-sm btn-outline-danger w-100" onClick={resetFilters}>Reset</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover table-bordered align-middle mb-0" style={{ fontSize: '13px' }}>
            <thead style={{ background: '#90b732', color: '#fff' }}>
              <tr>
                <th style={{ width: '36px' }}>
                  <input type="checkbox" className="form-check-input"
                    checked={selected.length === filteredData.length && filteredData.length > 0}
                    onChange={toggleAll} />
                </th>
                <th>#</th><th>Name</th><th>Course</th><th>Mobile</th>
                <th>Email</th><th>City</th><th>Added Date</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? filteredData.map((r, i) => (
                <tr key={r.id} className={selected.includes(r.id) ? 'table-primary' : ''}>
                  <td><input type="checkbox" className="form-check-input" checked={selected.includes(r.id)} onChange={() => toggleSelect(r.id)} /></td>
                  <td className="text-muted">{i + 1}</td>
                  <td className="fw-semibold">{r.name || '—'}</td>
                  <td><span className="badge bg-light text-dark border">{r.course || '—'}</span></td>
                  <td>{r.mobile || '—'}</td>
                  <td>{r.email || '—'}</td>
                  <td>{r.city || '—'}</td>
                  <td>{r.date ? new Date(r.date).toLocaleDateString() : '—'}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary py-0 px-2" title="Edit" onClick={() => setEditRecord(r)}>
                      <i className="bi bi-pencil"></i>
                    </button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="9" className="text-center text-muted py-4">No records found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Enrollstu;
